<div class="modal">
  <div>
    <div class="warning-container">
      <span class="material-symbols-outlined">warning</span><span class="warning-text">Attention!</span>
    </div>

    <div class="body-text">
      <p>You initially selected to enroll in plan year <b>{{data["planYear"]}}</b>. The enrollment election information you
        chose indicates you are eligible for coverage starting this year and coverage starting next year.  Since plan
        benefits and premiums may change, information related to your initial <b>{{data["planYear"]}}</b> selection may not
        be accurate if you choose coverage starting in <b>{{data["otherYear"]}}</b>.
      </p>
      <p>Note: If you would like to select different plans for each year, you will need to complete and submit two
        separate enrollment applications.</p>
      <p>Select <b>Continue</b> to stop this enrollment, return to the View Plans page and adjust your year selection.
      </p>
      <p>Select <b>Review entries</b> to return to this application and choose an effective date that matches the <b>{{data["planYear"]}}</b> year selected at the beginning of this enrollment process.</p>
    </div>

    <div class="buttons-container">
      <button (click)="goToReviewEntries()">
        Review entries
      </button>
      <button (click)="goToViewPlans()">
        Continue
      </button>
    </div>
  </div>
</div>